import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import CustomMultiselect from '@/components/ui/CustomMultiselect';
import { useGetCustomReports } from '@/hooks/useGetCustomReports';
import { BaseOptionType } from '@/components/ui/CustomMultiselect/types';
import { useApplicationContext } from '@/context/v1/Application/context';
import { FormItemWrapper } from '@/components/Settings/DataExtraction/styles';

const { useFormInstance, useWatch } = Form;

export function ReportFormItem(): JSX.Element {
	const form = useFormInstance();
	const { organization, company } = useApplicationContext();

	const selected: string[] = useWatch('report_type_id', form) || [];

	const { isLoading, data: rawReports } = useGetCustomReports({
		organization_id: organization?.id,
		company_id: company?.id
	});

	return (
		<FormItemWrapper name="report_type_id" label={I18n.get('Report')} labelCol={{ span: 24 }}>
			<CustomMultiselect
				options={rawReports as BaseOptionType[]}
				value={selected}
				onChange={(vals) => form.setFieldsValue({ report_type_id: vals })}
				placeholder={I18n.get('Report')}
				loading={isLoading}
			/>
		</FormItemWrapper>
	);
}
